/**
 * Choose one of your imported characters instead of describing one by hand. Picking a
 * character locks its class, race, faction and level: the server takes those from the
 * snapshot regardless of what the form sends, so showing them as editable would lie.
 */
import type { BuildOptionsResponse } from '@thottbot/shared';

type BuildCharacter = BuildOptionsResponse['characters'][number];

interface Props {
  characters: BuildCharacter[];
  value: string | null;
  onChange: (id: string | null) => void;
}

export function CharacterPicker({ characters, value, onChange }: Props) {
  if (characters.length === 0) return null;
  const picked = characters.find((c) => c.id === value) ?? null;

  return (
    <div className="field" data-testid="build-character-picker">
      <label htmlFor="build-character">Character</label>
      <select id="build-character" value={value ?? ''} onChange={(e) => onChange(e.target.value || null)}>
        <option value="">Enter a character by hand</option>
        {characters.map((c) => (
          <option key={c.id} value={c.id}>
            {c.name} &mdash; {c.realmName} (level {c.level} {c.race} {c.class})
          </option>
        ))}
      </select>
      {picked && (
        <p className="muted" data-testid="build-character-summary">
          Level {picked.level} {picked.faction} {picked.race} {picked.class}. Class, race, faction and level come from the
          imported character.
        </p>
      )}
    </div>
  );
}
